@if (activeDownloads().length > 0) {
  <fw-dialog class="operation-feedback" width="small" [showClose]="false">
    <fw-dialog-header>
      <div class="operation-feedback-header">
        @if (itemsInProgressCount()) {
          <span>{{ itemsInProgressCount() }} download{{ itemsInProgressCount() === 1 ? '' : 's' }} in progress</span>
        } @else {
          {{ finishedItemsCount() }} download{{ finishedItemsCount() === 1 ? '' : 's' }} finished
        }
        <div class="operation-feedback-header-actions">
          <fw-icon-button
            color="slate"
            size="small"
            test-id="toggle-feedback-panel"
            [icon]="isOpen ? 'chevron-down' : 'chevron-up'"
            (click)="isOpen = !isOpen"
          />
          <div>
            <fw-icon-button
              color="slate"
              icon="close"
              size="small"
              test-id="close-feedback-panel"
              (click)="onCloseClick()"
            />
            <div #popoverTrigger class="operation-feedback-header-actions-popover-trigger"></div>
          </div>
          <fw-popover action="click" position="above-left" [trigger]="popoverTrigger">
            <operation-cancel-popover-body
              cancelTitle="No, do not cancel"
              submitTitle="Yes, cancel download"
              text="If you choose to cancel, the download will be finished, and all files in progress will be deleted."
              title="Are you sure you want to cancel?"
              (cancelClick)="closePopover()"
              (submitClick)="onCancelDownloads()"
            />
          </fw-popover>
        </div>
      </div>
    </fw-dialog-header>

    <fw-dialog-content>
      @if (isOpen) {
        <div @toggle>
          <div class="operation-feedback-body" [class.scrollable]="isOpen">
            @for (download of activeDownloads(); track trackByOperationFeedbackItem($index, download)) {
              <operation-feedback-item
                [data]="download"
                (cancelClick)="onCancelDownload($event)"
                (refresh)="onRetryDownload($event)"
              />
            }
          </div>
        </div>
      }
    </fw-dialog-content>
  </fw-dialog>
}
